/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_zoi__nottobemissed3 = /** @type {(inputs: {}) => string} */ () => {
	return `Nicht verpassen`
};

const en_zoi__nottobemissed3 = /** @type {(inputs: {}) => string} */ () => {
	return `Not to be missed`
};

const es_zoi__nottobemissed3 = /** @type {(inputs: {}) => string} */ () => {
	return `No se lo pierda`
};

const fr_zoi__nottobemissed3 = /** @type {(inputs: {}) => string} */ () => {
	return `À ne pas manquer`
};

const it_zoi__nottobemissed3 = /** @type {(inputs: {}) => string} */ () => {
	return `Da non perdere`
};

const nl_zoi__nottobemissed3 = /** @type {(inputs: {}) => string} */ () => {
	return `Niet te missen`
};

const pt_zoi__nottobemissed3 = /** @type {(inputs: {}) => string} */ () => {
	return `A não perder`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const zoi__nottobemissed3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.zoi__nottobemissed3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("zoi__nottobemissed3", locale)
	if (locale === "de") return de_zoi__nottobemissed3(inputs)
	if (locale === "en") return en_zoi__nottobemissed3(inputs)
	if (locale === "es") return es_zoi__nottobemissed3(inputs)
	if (locale === "fr") return fr_zoi__nottobemissed3(inputs)
	if (locale === "it") return it_zoi__nottobemissed3(inputs)
	if (locale === "nl") return nl_zoi__nottobemissed3(inputs)
	return pt_zoi__nottobemissed3(inputs)
};
export { zoi__nottobemissed3 as "zoi__notToBeMissed" }